/**
 * Explanatory copy shown at the top of profile field selection screens.
 * Keyed by Pipedrive field code — add entries for any enum, set, or people field
 * that opens a selection subpage.
 */
import { i18n } from "../../../i18n";
import {
    INVOICE_RECIPIENT_FIELD_CODE,
    PRIMARY_CONTACT_FIELD_CODE,
} from "./profileFormGroups";

export const PROFILE_FIELD_DESCRIPTIONS: Record<string, string> = {
    // Parent — Family & pickup
    "549e79dc9a0ea05d247715f0fe1ef3296fc0cd0d": "livingWithParent",
    fe25d20b90ce2dfcfeee079db86e46fec2ca3376: "legalCustody",
    "270e09bf6ebcee59de8587e71713f09ff1ab1854": "pickupPermission",

    // Student — School
    "953eeea522e19cf47ad0bf935f9ec89a02edc61e": "citizenshipStatus",
    // Student — Medical
    d50dfcd5ec71ae3dacd22d28981f65f3fb3e46ea: "allergies",
    "97374cfbb19d0e89ba88f3d1fda894715fcdfce5": "dietaryRestrictions",
    c1b8b9b012e5cb8095a5a2c6dbdc3c30bc8eb18a: "healthInsuranceCompany",

    // Student — Family & permissions
    [PRIMARY_CONTACT_FIELD_CODE]: "primaryContact",
    [INVOICE_RECIPIENT_FIELD_CODE]: "invoiceRecipient",
    "0bf053c7ef333d473974f967c39caa2b72a0e79b": "pickupPermissionDays",
};

export function getProfileFieldDescription(
    fieldCode: string,
): string | undefined {
    return PROFILE_FIELD_DESCRIPTIONS[fieldCode]
        ? i18n.t(
              `profile.fieldDescriptions.${PROFILE_FIELD_DESCRIPTIONS[fieldCode]}`,
          )
        : undefined;
}
